<template>
  <div class="flex flex-col justify-center h-full cursor-pointer" :class="{'cursor-not-allowed opacity-75': disabled}">
    <div
        class="
        border
        w-full
        mr-6
        bg-white
        rounded-lg
        p-6
        hover:cursor-pointer
        border-solid
        h-full
        relative
      "
      :class="{
        'border-pink': activeOption === optionName,
        'border-grey-300': activeOption !== optionName || disabled,
      }"
      tabindex="0"
      @click="updateActiveOption"
      @keydown.space="updateActiveOption"
    >
      <div class="flex justify-center items-center mb-3">
        <component
          :is="optionIcon"
          class="checkoutRadioIcon text-pink"
        />
      </div>

      <div class="mb-1 font-semibold text-center">
        <p
          class="text-md"
          :class="{
            'text-pink': activeOption === optionName,
            'text-grey-700': activeOption !== optionName || disabled,
          }"
        >
          {{ optionName }}
        </p>
      </div>

      <div class="mb-1 text-center">
        <slot name="description"> </slot>
      </div>

      <div class="mb-1 font-semibold text-center" v-if="comingSoon">
        <p class="text-sm">({{ $t('frontend_coming_soon') }})</p>
      </div>
      <div v-if="overlay" class="overlayMessage"><div v-html="overlay"></div></div>
    </div>
  </div>
</template>

<script>
import DomainsIcon from '../assets/domains.svg';
import GrooveIcon from '../assets/groove-logo.svg';

export default {
  name: 'IconRadio',
  components: {
    DomainsIcon,
    GrooveIcon
  },
  model: {
    prop: 'activeOption',
    event: 'onUpdateOption'
  },
  props: {
    optionName: {},
    optionIcon: {},
    activeOption: {},
    description: {},
    comingSoon: {},
    overlay: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateActiveOption() {
      if (this.comingSoon || this.disabled) {
      } else {
        this.$emit('onUpdateOption', this.optionName);
      }
    }
  }
};
</script>

<style scoped>
.checkoutRadioIcon {
  width: 80px;
  height: 80px;
}
.overlayMessage {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  display: flex;
  color: white;
  background-color: rgba(25, 28, 60, .9);
  backdrop-filter: blur(4px);
}

.overlayMessage > div {
  margin: 0 20px;
}
</style>